import Layout from "../Components/Layout";
import Title from "../Components/UI/Title";
import PageContent from "../Components/UI/PageContent";

function LegalPage() {
  return (
    <Layout>
      <PageContent className="!py-10 md:!py-14">
        <div className="section-stack">
          <Title title="Legal Notices" />

          <div className="glass-card p-8 md:p-10 flex flex-col gap-5 text-sm text-muted leading-relaxed">
            <span className="text-xs uppercase tracking-wider font-semibold text-muted">
              Effective as of 01/02/2026
            </span>

            <p>
              In accordance with the provisions of Articles 6-III and 19 of Law
              No. 2004-575 of June 21, 2004 for Confidence in the Digital
              Economy, known as the L.C.E.N., users and visitors, hereinafter
              the &quot;User&quot;, of the site www.the-javascript-wizard.com,
              hereafter the &quot;Site&quot;, are informed of the present legal
              notice.
            </p>
            <p>
              The connection and navigation on the Site by the User implies full
              and unreserved acceptance of these legal notices.
            </p>
            <p>
              The latter are accessible on the Site under the heading
              &quot;Legal Notice&quot;.
            </p>

            <h3 className="font-bold text-ink mt-2">
              ARTICLE 1 - THE PUBLISHER
            </h3>

            <p>
              The editing and the direction of the publication of the Site is
              ensured by LOUIS Eden, domiciled at 27510 Mezieres en Vexin, whose
              e-mail address is eden.sans.gene@gmail.com.
            </p>
            <p>hereafter the &quot;Publisher&quot;.</p>

            <h3 className="font-bold text-ink mt-2">ARTICLE 2 - THE HOST</h3>

            <p>
              The host of the Site is the company The Javascript Wizard, whose
              head office is located at 27510 Mezieres en Vexin, with the
              contact email address eden.sans.gene@gmail.com
            </p>

            <h3 className="font-bold text-ink mt-2">
              ARTICLE 3 - ACCESS TO THE SITE
            </h3>

            <p>
              The Site is accessible anywhere, 7 days a week, 24 hours a day,
              except in case of force majeure, scheduled or unscheduled
              interruption and which may result from a maintenance necessity. In
              the event of modification, interruption or suspension of the Site,
              the Editor cannot be held responsible.
            </p>

            <h3 className="font-bold text-ink mt-2">
              ARTICLE 4 - DATA COLLECTION
            </h3>

            <p>
              The Site is exempted from declaration to the National Commission
              for Data Processing and Liberties (CNIL) insofar as it does not
              collect personal information.
            </p>

            <p>
              Any use, reproduction, distribution, marketing, modification of
              all or part of the Site, without the authorization of the Editor
              is prohibited and may result in legal action and prosecution as
              provided for in particular by the Code of Intellectual Property
              and the Civil Code.
            </p>

            <h3 className="font-bold text-ink mt-2">
              ARTICLE 5 - PRIVACY POLICY
            </h3>

            <p>
              In France, personal data are protected by the law n° 78-87 of
              January 6, 1978, the law n° 2004-801 of August 6, 2004, the
              article L. 226-13 of the Penal Code and the European Directive of
              October 24, 1995.
            </p>

            <p>
              When using the site, the following information may be collected:
              the URL of the links through which the user accessed the site, the
              user&apos;s access provider, the user&apos;s Internet protocol
              (IP) address.
            </p>

            <p>
              In any case, The Javascript Wizard only collects personal
              information relative to the user if the latter consents to it, by
              proceeding to their seizure, within the framework of a contact
              form, without any obligation to provide this information.
            </p>

            <h4 className="font-semibold text-ink mt-2">
              ARTICLE 5.1 - CONTACT FORM
            </h4>

            <p>
              The information collected on the contact form of the Site is sent
              by e-mail to make commercial proposals related to the services of
              The Javascript Wizard.This information is sent by the https
              protocol under an SSL certificate allowing to protect the
              information during its sending. They are kept for 1 year and are
              intended for LOUIS Eden. These data are the following: <br />
              - Name <br />
              - E-mail address
              <br />- Free message in which other personal data could be filled
              in by the user
            </p>

            <p>
              The data provided is only stored on the e-mail box of LOUIS Eden.
              The devices where these data are accessible (cell phones and
              computers) are protected by a password. In any case, the user can
              refuse to provide his personal data. In this case, he will not be
              able to send a form.
            </p>

            <p>
              In accordance with the law &quot;informatique et libertés&quot;,
              any user has a right of access, rectification and opposition to
              personal data concerning him by contacting : LOUIS Eden, via
              eden.sans.gene@gmail.com. No personal information of the user of
              the Site is published without the user&apos;s knowledge,
              exchanged, transferred, ceded or sold on any medium to third
              parties.
            </p>

            <h4 className="font-semibold text-ink mt-2">
              ARTICLE 5.2 - HYPERTEXT LINKS AND COOKIES
            </h4>

            <p>
              The Site contains a number of hypertext links to other sites, set
              up with the authorization of LOUIS Eden. However, the owner does
              not have the possibility of checking the contents of the sites
              thus visited, and consequently will not assume any responsibility
              of this fact.
            </p>

            <p>
              The navigation on the Site is likely to cause the installation of
              cookie(s) on the user&apos;s computer. A cookie is a small file,
              which does not allow the identification of the user, but which
              records information relating to the navigation of a computer on a
              site. We automatically collect only those cookies that are
              essential to the proper functioning of the website during a simple
              navigation. In no case the Site uses third party companies to
              collect personal information.{" "}
            </p>

            <h3 className="font-bold text-ink mt-2">
              ARTICLE 6 - APPLICABLE LAW AND JURISDICTION
            </h3>

            <p>
              Any dispute in connection with the use of the site
              www.the-javascript-wizard.com is subject to French law. Exclusive
              jurisdiction is given to the competent courts of Paris.{" "}
            </p>
          </div>
        </div>
      </PageContent>
    </Layout>
  );
}

export default LegalPage;
